module.exports = __webpack_public_path__ + "img/korea_rounded.71d0906f.jpg";